import { render, staticRenderFns } from "./IconSuccess.vue?vue&type=template&id=4b52a156&scoped=true&"
import script from "./IconSuccess.vue?vue&type=script&lang=js&"
export * from "./IconSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52a156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b52a156')) {
      api.createRecord('4b52a156', component.options)
    } else {
      api.reload('4b52a156', component.options)
    }
    module.hot.accept("./IconSuccess.vue?vue&type=template&id=4b52a156&scoped=true&", function () {
      api.rerender('4b52a156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconSuccess.vue"
export default component.exports